import { FaUnity } from 'react-icons/fa'

import type { ICellRendererParams } from 'ag-grid-enterprise'
import type { ReactElement } from 'react'

import AppStoreLogo from '~/assets/app-store-logo.png'
import GooglePlayStoreLogo from '~/assets/google-play-store-logo.png'
import WebLogo from '~/assets/web-logo.png'

import './styles.scss'

const PlatformCellRenderer = ({ data, value }: ICellRendererParams): ReactElement | null => {
  return value === 'android' ? (
    <div className="ag-react-container">
      <div className="platform-icon google-store-logo-container">
        <img alt="google store logo" className="google-store-logo" src={GooglePlayStoreLogo} />
        {data?.isUnity ? <FaUnity className="platform-icon unity-logo" size={14} /> : null}
      </div>
    </div>
  ) : value === 'ios' ? (
    <div className="platform-icon app-store-logo-container">
      <img alt="app store logo" className="app-store-logo" src={AppStoreLogo} />
      {data?.isUnity ? <FaUnity className="unity-logo" size={14} /> : null}
    </div>
  ) : value === 'web' ? (
    <div className="platform-icon app-store-logo-container">
      <img alt="web-logo" className="app-store-logo" src={WebLogo} />
    </div>
  ) : (
    <div />
  )
}

export default PlatformCellRenderer
